require('./resize')

const destinationsList = require('./destinations-list')

window.airiane = window.airiane || {}

window.airiane = {
  destinationsList,
}
